(function () {
  'use strict';
  class Controller {
    constructor($window, $state, $stateParams) {
      this.history = $window.history;
      this.$state = $state;
      this.$stateParams = $stateParams;
    }
    back() {
      this.history.back();
    }
  }
  angular
    .module('display.update', [])
    .component('displayUpdate', {
      controller: Controller,
      templateUrl: 'root/display/update/update-display.route.html'
    })
    .config(function ($stateProvider) {
      $stateProvider
        .state('display.update', {
          abstract: false,
          url: '/update',
          template: '<display-update/>'
        });
    });
}());
